import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase/config";

const MODES = new Set(["beginner", "easy", "intermediate", "hard", "master"]);

const usersCollection = () => {
  if (process.env.REACT_APP_FIREBASE_USERS_COLLECTION) {
    return process.env.REACT_APP_FIREBASE_USERS_COLLECTION;
  }
  const isProduction =
    process.env.REACT_APP_FIREBASE_ENV === "production" ||
    (process.env.REACT_APP_FIREBASE_ENV !== "development" &&
      process.env.NODE_ENV === "production");
  return isProduction ? "production_users" : "users";
};

const storageKey = (userId) => `arcadeChessNotify:${userId}`;

const asNotify = (value) => {
  if (value && value.on === true && MODES.has(value.mode)) {
    return { on: true, mode: value.mode };
  }
  return null;
};

export const readLocalChessNotify = (userId) => {
  if (!userId) return null;
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return null;
    return asNotify(JSON.parse(raw));
  } catch {
    return null;
  }
};

const writeLocalChessNotify = (userId, value) => {
  if (!userId) return;
  try {
    if (!value) window.localStorage.removeItem(storageKey(userId));
    else window.localStorage.setItem(storageKey(userId), JSON.stringify(value));
  } catch {
    // Ignore storage failures. Firestore may still have the preference.
  }
};

export const loadChessNotify = async (userId) => {
  const local = readLocalChessNotify(userId);
  if (!db || !userId) return local;
  try {
    const snap = await getDoc(doc(db, usersCollection(), userId));
    if (!snap.exists() || !Object.prototype.hasOwnProperty.call(snap.data(), "chessNotify")) {
      return local;
    }
    const saved = asNotify(snap.data().chessNotify);
    writeLocalChessNotify(userId, saved);
    return saved;
  } catch {
    return local;
  }
};

export const saveChessNotify = async (userId, mode) => {
  const value = asNotify({ on: true, mode });
  if (!value) return;
  writeLocalChessNotify(userId, value);
  if (!db || !userId) return;
  try {
    await setDoc(
      doc(db, usersCollection(), userId),
      { chessNotify: value, lastUpdated: new Date() },
      { merge: true }
    );
  } catch {
    // localStorage already has the preference.
  }
};

export const clearChessNotify = async (userId) => {
  writeLocalChessNotify(userId, null);
  if (!db || !userId) return;
  try {
    await setDoc(
      doc(db, usersCollection(), userId),
      { chessNotify: null, lastUpdated: new Date() },
      { merge: true }
    );
  } catch {
    // localStorage is already cleared.
  }
};
